import { apiGet, apiPost } from './utils';
import type { DwollaStatus, DwollaSource, DwollaTransaction } from '../types';

export const dwollaApi = {
  async getStatus(): Promise<DwollaStatus> {
    return apiGet<DwollaStatus>('/dwolla/status');
  },

  async createCustomer(data: {
    first_name: string;
    last_name: string;
    email: string;
  }): Promise<DwollaStatus & { success: boolean }> {
    return apiPost<DwollaStatus & { success: boolean }>('/dwolla/customer', data);
  },

  async getSources(): Promise<{ sources: DwollaSource[]; default_source: string | null }> {
    return apiGet<{ sources: DwollaSource[]; default_source: string | null }>('/dwolla/sources');
  },

  async addFundingSource(data: {
    routing_number: string;
    account_number: string;
    account_type: 'checking' | 'savings';
    name?: string;
  }): Promise<{ success: boolean; has_funding_source: boolean }> {
    return apiPost<{ success: boolean; has_funding_source: boolean }>('/dwolla/sources', data);
  },

  async removeSource(fundingLocation?: string): Promise<{ success: boolean }> {
    return apiPost<{ success: boolean }>('/dwolla/remove-source', {
      funding_location: fundingLocation,
    });
  },

  async getTransactions(): Promise<{ transactions: DwollaTransaction[] }> {
    return apiGet<{ transactions: DwollaTransaction[] }>('/dwolla/transactions');
  },
};
